import ObjectHeading from "@/components/ObjectHeading";
import PageTitle from "@/components/PageTitle";
import { useQuery } from "@apollo/client";
import { SectionData } from "../audit-log/types";
import { SECTION_DETAILS_HEADER_QUERY } from "../queries";
import { ProfileSkeleton } from "@/components/Skeleton";
import { Params, Path } from "@/router";
import { LinkProps } from "@generouted/react-router/client";
import type { Action } from "@/components/MenuButton";

type ObjectHeadingWrapper = {
  sectionId: string;
  actionButtons?: Action[];
  isDetailsViewDesktop?: boolean;
};

export const ObjectHeadingWrapper = ({ sectionId, actionButtons, isDetailsViewDesktop }: ObjectHeadingWrapper) => {
  const { data, loading, error } = useQuery<SectionData>(SECTION_DETAILS_HEADER_QUERY, {
    variables: { sectionId }
  });

  if (loading) return <ProfileSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const { section } = data!;

  return (
    <>
      <PageTitle
        pattern={`/sections/:sectionId/change-requests`}
        title={`Sections | Section Details | Change Requests | ${data?.section.name}`}
      />
      <ObjectHeading
        title={section.name}
        actions={actionButtons}
        isDetailsView
        isDetailsViewDesktop={isDetailsViewDesktop}
      />
    </>
  );
};

type Props<P extends Path> = {
  sectionId: string;
  actionButtons?: Action[];
  backLink?: LinkProps<P, Params>;
};

export function SectionDetailsHeader<P extends Path>({ sectionId, actionButtons }: Props<P>) {
  return (
    <div data-testid="section-details-header">
      <ObjectHeadingWrapper sectionId={sectionId} actionButtons={actionButtons} />
    </div>
  );
}

SectionDetailsHeader.defaultProps = {
  backLink: { to: "/sections" }
};
